<ish-error-message [error]="error$ | async" />

<div class="registration-header">
  <h1 class="registration-title text-center font-50 my-4 text-capitalize">
    {{ 'dias.account.register.heading' | translate }}
  </h1>
</div>
<div data-testing-id="account-create-full-page" class="registration-form-block">
  <form [formGroup]="form" ishFormSubmit #registrationForm="ngForm" (ngSubmit)="onCreate()" novalidate>
    <formly-form [model]="model" [form]="form" [options]="options" [fields]="fields" />
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="row form-group">
          <div class="col-md-6 col-12">
            <input
              type="submit"
              [disabled]="form.invalid && registrationForm.submitted"
              class="btn btn-primary"
              value="{{ 'account.create.button.label' | translate }}"
            />
          </div>
          <div class="col-md-6 col-12 register-back-button">
            <input
              type="button"
              class="btn btn-link"
              value="{{ 'dias.account.cancel.link' | translate }}"
              (click)="cancelForm()"
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ish-lazy-address-doctor />
<ish-loading *ngIf="loading$ | async" />
